import { useSyncExternalStore } from 'react'

/** True while the media query matches; false during server rendering (there is none). */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const media = matchMedia(query)
      media.addEventListener('change', onChange)
      return () => media.removeEventListener('change', onChange)
    },
    () => matchMedia(query).matches,
    () => false,
  )
}

/** Tailwind `lg`: the sidebar expands from here. */
export const LG_QUERY = '(min-width: 1024px)'
